import Vue from "vue";
import wx from "weixin-js-sdk";
import API from "@/axios/api";
import store from "@/store";

Vue.prototype.$setime = function (value, type) {
  //this.iset = false;
  let date = new Date(value);
  let y = date.getFullYear();
  let MM = date.getMonth() + 1;
  MM = MM < 10 ? "0" + MM : MM;
  let d = date.getDate();
  d = d < 10 ? "0" + d : d;
  let h = date.getHours();
  h = h < 10 ? "0" + h : h;
  let m = date.getMinutes();
  m = m < 10 ? "0" + m : m;
  let s = date.getSeconds();
  s = s < 10 ? "0" + s : s;
  if (type == 1) {
    var dat = y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
  } else if (type == 2) {
    var dat = y + "-" + MM + "-" + d;
  } else if (type == 3) {
    var dat = y + "-" + MM + "-" + d + " " + h + ":" + m;
  }
  return dat;
};
Vue.prototype.$pageLoginOut = function () {
  let _this = this;
  _this.$dailog
    .confirm({
      title: "退出登录确认",
      message: "退出登录后，可以再次登录体验"
    })
    .then(() => {
      _this.$loginOut();
      _this.$toast("退出登录成功");
      _this.$router.push("/loginEnter");
    });
};
//首次进入页面初始化执行
Vue.prototype.$intoInit = function () {
  let _this = this;
  $token = localStorage.getItem("token");
  if (_this.$isblank($token)) {
    _this.$loginOut();
  }
};

//获取url参数=====H5
Vue.prototype.$getQueryVariable = function (name) {
  if (name == null || name == "undefined") {
    return null;
  }
  var searchStr = decodeURI(location.search);
  var infoIndex = searchStr.indexOf(name + "=");
  if (infoIndex == -1) {
    return null;
  }
  var searchInfo = searchStr.substring(infoIndex + name.length + 1);
  var tagIndex = searchInfo.indexOf("&");
  if (tagIndex != -1) {
    searchInfo = searchInfo.substring(0, tagIndex);
  }
  return searchInfo;
};

//删除url参数=====H5
Vue.prototype.$delQueryVariable = function (url, parameter) {
  var urlparts = url.split("?");
  if (urlparts.length >= 2) {
    //参数名前缀
    var prefix = encodeURIComponent(parameter) + "=";
    var pars = urlparts[1].split(/[&;]/g);
    //循环查找匹配参数
    for (var i = pars.length; i-- > 0;) {
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        //存在则删除
        pars.splice(i, 1);
      }
    }
    return urlparts[0] + (pars.length > 0 ? "?" + pars.join("&") : "");
  }
  return url;
};

// 路由跳转，path为需要跳转的路由，eg： this.$toTurn('/index')
Vue.prototype.$toTurn = function (path) {
  this.$router.push(path);
};

// 判断当前设备，微信端 或 其他浏览器
Vue.prototype.$judgeUserAgent = function () {
  var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    this.$store.commit("updateAgent", true);
  } else {
    this.$store.commit("updateAgent", false);
  }
};

// 判断数据是否为空
Vue.prototype.$isblank = function (chr) {
  if (
    chr == null ||
    chr == "" ||
    chr == undefined ||
    chr == "undefined" ||
    chr == "null" ||
    chr.length == 0
  ) {
    return true;
  }
  var chr = chr.toString();
  var chr = chr.replace(/(^\s*)|\s*$/g, "");
  if (
    chr == null ||
    chr == "" ||
    chr == undefined ||
    chr == "undefined" ||
    chr == "null" ||
    chr.length == 0
  ) {
    return true;
  }
  return false;
};

// +----------------------------------------------------------------------
// | Desc: 时间戳转化为时间格式
// +----------------------------------------------------------------------
// | Param:time十位数时间戳
// | Param:type，1(2018-01-01 10:12:11),2(2018-01-01 10:12),3(2018-01-01),4(2018-01),5(2018),默认(2018-01-01)
// +----------------------------------------------------------------------
// | return:格式化后的时间
// +----------------------------------------------------------------------
Vue.prototype.$timeFmt = function (time, type) {
  if (this.$isblank(time)) {
    return "";
  } else {
    var ts = arguments[0] || 0;
    var t, y, m, d, h, i, s;
    t = ts ? new Date(ts * 1000) : new Date();
    y = t.getFullYear();
    m = t.getMonth() + 1;
    d = t.getDate();
    h = t.getHours();
    i = t.getMinutes();
    s = t.getSeconds();
    // 可根据需要在这里定义时间格式
    if (type == 1) {
      return (
        y +
        "-" +
        (m < 10 ? "0" + m : m) +
        "-" +
        (d < 10 ? "0" + d : d) +
        " " +
        (h < 10 ? "0" + h : h) +
        ":" +
        (i < 10 ? "0" + i : i) +
        ":" +
        (s < 10 ? "0" + s : s)
      );
    } else if (type == 2) {
      return (
        y +
        "-" +
        (m < 10 ? "0" + m : m) +
        "-" +
        (d < 10 ? "0" + d : d) +
        " " +
        (h < 10 ? "0" + h : h) +
        ":" +
        (i < 10 ? "0" + i : i)
      );
    } else if (type == 3) {
      return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d);
    } else if (type == 4) {
      return y + "-" + (m < 10 ? "0" + m : m);
    } else if (type == 5) {
      return y + "-" + (m < 10 ? "0" + m : m);
    } else {
      return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d);
    }
  }
};

// 格式化处理金额, money: 金额数值 eg: 1600.00
Vue.prototype.$fmtMoney = function (money) {
  if (this.$isblank(money)) {
    return "0.00";
  } else {
    money = Number(parseInt(money) / 100).toFixed(2);
    return money;
  }
};

//正则验证
Vue.prototype.$valid = function (str, reg) {
  if (reg == "id") {
    reg = "/^+?[1-9][0-9]*$/";
  } else if (reg == "tel") {
    reg = /^1[3456789]\d{9}$/;
  } else if (reg == "code") {
    reg = /^([0-9]{4})$/;
  }
  var r = reg.test(str);
  if (!r) {
    return true;
  } else {
    return false;
  }
};

//根据防癌检测方案类型返回防癌检测方案标志
Vue.prototype.$getGoodsSign = function (type) {
  type = parseInt(type);
  switch (type) {
    case 1:
      return "36";
    case 2:
      return "weichangwaike";
    case 3:
      return "shidaoai";
    case 4:
      return "gan1";
    case 5:
      return "fei1";
  }
};

//健康卡信息格式化
Vue.prototype.$couponFmt = function (type) {
  var obj = new Object();
  if (type == 1) {
    obj["title"] = "防癌检测方案健康卡";
    obj["intro"] = "结直肠防癌检测健康卡";
    obj["means"] = "线下事物领取";
  }
  if (type == 2) {
    obj["title"] = "防癌检测方案健康卡";
    obj["intro"] = "胃部防癌检测";
    obj["means"] = "线下事物领取";
  }
  if (type == 3) {
    obj["title"] = "防癌检测方案健康卡";
    obj["intro"] = "肠+胃防癌检测健康卡";
    obj["means"] = "线下事物领取";
  }
  if (type == 4) {
    obj["title"] = "防癌检测方案健康卡";
    obj["intro"] = "肠+肺防癌检测";
    obj["means"] = "线下事物领取";
  }
  if (type == 5) {
    obj["title"] = "防癌检测方案健康卡";
    obj["intro"] = "肠+胃+食道+肝防癌检测";
    obj["means"] = "线下事物领取";
  }
  if (type == 6) {
    obj["title"] = "防癌检测方案健康卡";
    obj["intro"] = "肠+胃+食道+肝+肺防癌检测健康卡";
    obj["means"] = "线下事物领取";
  }
  if (type == 7) {
    obj["title"] = "绿之源健康卡";
    obj["intro"] = "绿之源商城平台健康卡";
    obj["means"] = "绿之源商城使用,点击领取";
  }
  return obj;
};

//判断是不是处于登录状态，1表示判断pad登录
Vue.prototype.$isloginJump = function (type) {
  if (type == 1) {
    let urlindex = "/loginEnter";
    let urlbind = "/emberServeBind";
    let urlchooseSubscribe = "/emberServeQuestion";
  }

  let _this = this;
  $user_id = _this.$store.state.user_id;
  $user_tel = _this.$store.state.user_tel;
  $token = localStorage.getItem("token");
  JSON.parse(localStorage.getItem("user"));
  $user = JSON.parse(localStorage.getItem("user"));
  if (_this.$isblank($user_id) || _this.$isblank($token)) {
    //如果localStorage都不为空
    if ($user["user_id"] && $user["token"]) {
      _this.$router.push(urlindex);
      return;
    }
    //重新赋值
    _this.$store.commit("updateUserInfo", user);
    $token = localStorage.getItem("token");
    $user_id = _this.$store.state.user_id;
    $user_tel = _this.$store.state.user_tel;

    //重新判断跳转
    if (_this.$isblank($user_id) || _this.$isblank($token)) {
      _this.$router.push(urlindex);
      return;
    }
    if (_this.$isblank($user_tel)) {
      _this.$router.push(urlbind);
    } else {
      _this.$router.push(urlchooseSubscribe);
    }
  } else {
    if (_this.$isblank($user_tel)) {
      _this.$router.push(urlbind);
    } else {
      _this.$router.push(urlchooseSubscribe);
    }
  }
};

//微信扫码样式重置
Vue.prototype.$wxscanqrcode =
  "data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIwMHB4O30NCi5pbXBvd2VyQm94IC50aXRsZSB7ZGlzcGxheTogbm9uZTt9DQouaW1wb3dlckJveCAuaW5mbyB7d2lkdGg6IDIwMHB4O30NCi5zdGF0dXNfaWNvbiB7ZGlzcGxheTogbm9uZX0NCi5pbXBvd2VyQm94IC5zdGF0dXMge3RleHQtYWxpZ246IGNlbnRlcjt9IA==";

//返回上一页
Vue.prototype.$goBack = function () {
  this.$router.back(-1);
};

/**
 * 十位数时间戳
 * 将一个日期格式化成友好格式，比如，1分钟以内的返回“刚刚”，
 * 当天的返回时分，当年的返回月日，否则，返回年月日
 * @param {Object} date
 */
Vue.prototype.$friendlytime = function (fromDateString) {
  if (this.$isblank(fromDateString)) {
    return "";
  }
  var ts = arguments[0] || 0;
  var t, y, m, d, h, i, s;
  t = ts ? new Date(ts * 1000) : new Date();
  y = t.getFullYear();
  m = t.getMonth() + 1;
  d = t.getDate();
  h = t.getHours();
  i = t.getMinutes();
  s = t.getSeconds();
  fromDateString =
    y +
    "-" +
    (m < 10 ? "0" + m : m) +
    "-" +
    (d < 10 ? "0" + d : d) +
    " " +
    (h < 10 ? "0" + h : h) +
    ":" +
    (i < 10 ? "0" + i : i) +
    ":" +
    (s < 10 ? "0" + s : s);
  if (fromDateString === undefined || fromDateString === "") {
    return fromDateString;
  }
  //当前日期以及对应的年月日时分秒
  var nowDate = new Date();
  let nowDateYear = nowDate.getFullYear(); // 年份，注意必须用getFullYear
  let nowDateMonth = nowDate.getMonth() + 1; // 月份，注意是从0-11
  let nowDateDay = nowDate.getDate(); // 日期
  let nowDateHours = nowDate.getHours(); //24小时制
  let nowDateMinutes = nowDate.getMinutes(); // 分钟
  let nowDateSeconds = nowDate.getSeconds(); // 秒

  // console.log('nowDate = '+ nowDateYear+'-'+(nowDateMonth<10?+'0'+nowDateMonth:nowDateMonth)+'-'+(nowDateDay<10?+'0'+nowDateDay:nowDateDay)
  //     +' '+(nowDateHours<10?+'0'+nowDateHours:nowDateHours)+':'+(nowDateMinutes<10?+'0'+nowDateMinutes:nowDateMinutes)+':'+
  //     (nowDateSeconds<10?+'0'+nowDateSeconds:nowDateSeconds));
  // console.log('fromDate = '+ fromDateString);
  //传过来的日期以及对应的年月日时分秒
  var formDateArray = fromDateString.split(" ")[0].split("-");
  var fromTimeArray = fromDateString.split(" ")[1].split(":");
  let fromDateYear = formDateArray[0]; // 年份，注意必须用getFullYear
  let fromDateMonth = formDateArray[1]; // 月份，注意是从0-11
  let fromDateDay = formDateArray[2]; // 日期
  let fromDateHours = fromTimeArray[0]; //24小时制
  let fromDateMinutes = fromTimeArray[1]; // 分钟
  let fromDateSeconds = fromTimeArray[2]; // 秒
  //这部分是对05月01日 05时05分05秒这种进行格式化，判断的时候用这个
  let fromDateMonthTmp = fromDateMonth;
  if (fromDateMonth.substring(0, 1) === "0") {
    fromDateMonthTmp = fromDateMonth.substring(1, 2);
  }
  let fromDateDayTmp = fromDateDay;
  if (fromDateDay.substring(0, 1) === "0") {
    fromDateDayTmp = fromDateDay.substring(1, 2);
  }
  let fromDateHoursTmp = fromDateHours;
  if (fromDateHours.substring(0, 1) === "0") {
    fromDateHoursTmp = fromDateHours.substring(1, 2);
  }
  let fromDateMinutesTmp = fromDateMinutes;
  if (fromDateMinutes.substring(0, 1) === "0") {
    fromDateMinutesTmp = fromDateMinutes.substring(1, 2);
  }
  let fromDateSecondsTmp = fromDateSeconds;
  if (fromDateSeconds.substring(0, 1) === "0") {
    fromDateSecondsTmp = fromDateSeconds.substring(1, 2);
  }
  // console.log('nowDateInt = '+ nowDateYear+'-'+nowDateMonth+'-'+nowDateDay+' '+nowDateHours+':'+nowDateMinutes+':'+nowDateSeconds);
  // console.log('fromDateInt = '+ fromDateYear+'-'+fromDateMonthTmp+'-'+fromDateDayTmp+' '+fromDateHoursTmp+':'+fromDateMinutesTmp+':'+fromDateSecondsTmp);
  /******************* 一分钟之内 *******************/
  let nowDateYMDH =
    nowDateYear +
    "年" +
    nowDateMonth +
    "月" +
    nowDateDay +
    "日 " +
    nowDateHours;
  let fromDateYMDH =
    fromDateYear +
    "年" +
    fromDateMonthTmp +
    "月" +
    fromDateDayTmp +
    "日 " +
    fromDateHoursTmp;
  //需要比较的time, 1分钟以内视作“刚刚”
  if (nowDateYMDH === fromDateYMDH && nowDateMinutes - fromDateMinutesTmp < 2) {
    let remainMinuteSecond = (nowDateMinutes - fromDateMinutesTmp) * 60;
    let remainSecond = nowDateSeconds - fromDateSecondsTmp;
    console.log(
      "remainMinuteSecond = " +
      remainMinuteSecond +
      "    " +
      "remainSecond = " +
      remainSecond
    );
    console.log("remainSecond = " + remainSecond);
    if (remainMinuteSecond + remainSecond < 60 * 1000) {
      return "刚刚";
    }
  }
  /*************** 今天：只显示时间，格式为 时分      (已测试没问题) **********/
  //需要比较的 日期yyyy年M月d
  let nowDateYMD = nowDateYear + "年" + nowDateMonth + "月" + nowDateDay + "日";
  let fromDateYMD =
    fromDateYear + "年" + fromDateMonthTmp + "月" + fromDateDayTmp + "日";
  //返回时分
  if (nowDateYMD === fromDateYMD) {
    return fromDateHours + ":" + fromDateMinutes;
  }
  /*************** 昨天：不显示日期，显示“昨天”，格式为：“昨天” 时分； ***********/
  /*************** 前天：不显示日期，显示“前天”，格式为：“前天” 时分； ***********/
  let nowDateYM = nowDateYear + "年" + nowDateMonth + "月";
  let fromDateYM = fromDateYear + "年" + fromDateMonthTmp + "月";
  if (nowDateYM === fromDateYM) {
    if (nowDateDay - fromDateDayTmp === 1) {
      return "昨天 " + fromDateHours + ":" + fromDateMinutes;
    } else if (nowDateDay - fromDateDayTmp === 2) {
      return "前天 " + fromDateHours + ":" + fromDateMinutes;
    }
  }
  /******** 今年其他日期：不显示时间，仅显示月日，格式为：X月X日； ************/
  let nowDateY = nowDateYear + "年";
  let fromDateY = fromDateYear + "年";
  if (nowDateY === fromDateY) {
    return fromDateMonth + "月" + fromDateDay + "日";
  }
  /******* 其它年份：不显示时间，仅显示年月日，格式为：XXXX年XX月XX日； **********/
  return fromDateYear + "年" + fromDateMonth + "月" + fromDateDay + "日";
};

//微信分享组件
Vue.prototype.$wxshare = function (msg) {
  var _this = this;
  let ua = navigator.userAgent.toLowerCase();
  let iswechat = ua.match(/MicroMessenger/i) == "micromessenger";
  if (iswechat) {
    _this.$api
      .getJssdk({
        url: window.location.href
      })
      .then(response => {
        if (response.code == 0) {
          // 通过config接口注入权限验证配置
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，
            // 参数信息会通过log打出，仅在pc端时才会打印。
            appId: response.data.appId, // 必填，公众号的唯一标识
            timestamp: response.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: response.data.nonceStr, // 必填，生成签名的随机串
            signature: response.data.signature, // 必填，签名，见附录1
            jsApiList: [
              // 'checkJsApi',// 判断当前版本是否支持分享指定JS接口
              "onMenuShareTimeline", // 分享到朋友圈
              "onMenuShareAppMessage", // 分享到微信好友
              "onMenuShareQQ", // 分享到QQ
              "onMenuShareWeibo", // 分享到微博
              "onMenuShareQZone" // 分享到空间
            ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          /*eslint-disable */
          let share_config = {
            share: {
              imgUrl: msg.imgUrl, // 分享图，默认当相对路径处理，所以使用绝对路径的的话，“http://”协议前缀必须在。
              desc: msg.desc, // 摘要,如果分享到朋友圈的话，不显示摘要。
              title: msg.title, // 分享卡片标题
              link: msg.link, // 分享出去后的链接，这里可以将链接设置为另一个页面。
              success: function () {
                // 分享成功后的回调函数
              },
              cancel: function () {
                // 用户取消分享后执行的回调函数
              }
            }
          };
          // 点击修改要分享的内容
          wx.ready(function () {
            wx.onMenuShareAppMessage(share_config.share); // 分享给好友
            wx.onMenuShareTimeline(share_config.share); // 分享到朋友圈
            wx.onMenuShareQQ(share_config.share); // 分享到QQ
            wx.onMenuShareWeibo(share_config.share); // 分享到腾讯微博
            wx.onMenuShareQZone(share_config.share); // 分享到空间
          });

          wx.error(function (res) {
            // alert(res.errMsg);  //打印错误消息。及把 debug:false,设置为debug:ture就可以直接在网页上看到弹出的错误提示
          });
        }
      });
  } else {
    // console.log(`${store.state.uaType}浏览器不用索取微信分享签名了`)
    return;
  }
};

//去掉空格换行符
Vue.prototype.$trim = function (text) {
  if (this.$isblank(text)) {
    return "";
  }
  text = text.toString();
  return text.replace(/^\s*|\s*$/g, "");
};

//求两个集合的交集
Vue.prototype.$intersect = function (a, b) {
  let set1 = new Set(a),
    set2 = new Set(b);
  return [...new Set([...set1].filter(x => set2.has(x)))];
};

// 校验身份证
Vue.prototype.$idNoFormatCheck = function (value) {
  var num = value.toUpperCase();
  // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。
  var reg = /^(\d{18,18}|\d{15,15}|\d{17,17}X)$/;
  if (!reg.test(num)) {
    return false;
  }
  // 校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
  // 下面分别分析出生日期和校验位
  var len, re;
  len = num.length;
  if (len == 15) {
    re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
    var arrSplit = num.match(re);
    // 检查生日日期是否正确
    var dtmBirth = new Date(
      "19" + arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]
    );
    var bGoodDay;
    bGoodDay =
      dtmBirth.getYear() == Number(arrSplit[2]) &&
      dtmBirth.getMonth() + 1 == Number(arrSplit[3]) &&
      dtmBirth.getDate() == Number(arrSplit[4]);
    if (!bGoodDay) {
      return false;
    }
  }
  if (len == 18) {
    re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
    var arrSplit = num.match(re);
    // 检查生日日期是否正确
    var dtmBirth = new Date(
      arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]
    );
    var bGoodDay;
    bGoodDay =
      dtmBirth.getFullYear() == Number(arrSplit[2]) &&
      dtmBirth.getMonth() + 1 == Number(arrSplit[3]) &&
      dtmBirth.getDate() == Number(arrSplit[4]);
    if (!bGoodDay) {
      return false;
    } else {
      // 检验18位身份证的校验码是否正确。
      // 校验位按照ISO 7064:1983.MOD
      // 11-2的规定生成，X可以认为是数字10。
      var valnum;
      var arrInt = new Array(
        7,
        9,
        10,
        5,
        8,
        4,
        2,
        1,
        6,
        3,
        7,
        9,
        10,
        5,
        8,
        4,
        2
      );
      var arrCh = new Array(
        "1",
        "0",
        "X",
        "9",
        "8",
        "7",
        "6",
        "5",
        "4",
        "3",
        "2"
      );
      var nTemp = 0,
        i;
      for (var i = 0; i < 17; i++) {
        nTemp += num.substr(i, 1) * arrInt[i];
      }
      valnum = arrCh[nTemp % 11];
      if (valnum != num.substr(17, 1)) {
        return false;
      }
    }
  }
  return true;
};

// 前补白  "1" => "01"
Vue.prototype.$padStart = function (value, no = 2, str = "0") {
  return value.toString().padStart(no, str);
};

// 后补白  "1" => "10"
Vue.prototype.$padEnd = function (value, no = 2, str = "0") {
  return value.toString().padEnd(no, str);
};

/**
 * @desc 计算时间 输出 00:00:00
 * @param {number} timeStemp  单位:秒
 * @return {string}  00:00:00
 */
Vue.prototype.$calculationTime = function (timeStemp) {
  let time = timeStemp;
  if (time) {
    let h = 0,
      m = 0,
      s = 0,
      us = 1,
      um = 60 * us,
      uh = us * um * 60;

    // 时
    if (time >= uh) {
      h = Math.floor(time / uh);
    }
    // 分
    if (time >= um) {
      time = time - h * uh;
      m = Math.floor(time / um);
    }

    // 秒
    time = time - m * um;
    s = Math.floor(time / us);

    h = this.$padStart(h);
    m = this.$padStart(m);
    s = this.$padStart(s);

    return `${h}:${m}:${s}`;
  }

  return "00:00:00";
};

Vue.prototype.$isTestEnvironment = function () {
  const host = window.location.host;
  return host.indexOf("test") > -1 || host.indexOf("localhost") > -1;
};

Vue.prototype.$numDivision = function (num1, num2) {
  var baseNum1 = 0,
    baseNum2 = 0;
  var baseNum3, baseNum4;
  try {
    baseNum1 = num1.toString().split(".")[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split(".")[1].length;
  } catch (e) {
    baseNum2 = 0;
  }

  baseNum3 = Number(num1.toString().replace(".", ""));
  baseNum4 = Number(num2.toString().replace(".", ""));
  return (baseNum3 / baseNum4) * Math.pow(10, baseNum2 - baseNum1);
};

Vue.prototype.$openSSE = () => {
  let index = 0;
  const token = localStorage.getItem("token");
  const sse = new EventSource(API.subscript + `?token=${token}`);
  sse.onmessage = e => {
    if (e.data) {
      store.dispatch("subscribe", ++index);
      store.dispatch("subscribeMsg", JSON.parse(e.data));
    }
  };
  sse.onopen = e => {
    console.log("onopen:", e.data);
  };
  window.sse = sse;
};

// 防抖  在一段时间内 用户一直触发同一个事件，每次点击都打开一个定时器，定时器还存在时，清掉定时器。重新打开
Vue.prototype.$debounce = function (fn, delay = 500) {
  let timer = null; //借助闭包
  return function (...args) {
    //进入该分支语句，说明当前正在一个计时过程中，并且又触发了相同事件。所以要取消当前的计时，重新开始计时
    if (timer) clearTimeout(timer);
    // 进入该分支说明当前并没有在计时，那么就开始一个计时
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
};

// 节流 n 秒内只执行一次
Vue.prototype.$throttle = (fn, delay = 500) => {
  let valid = true;
  return function () {
    if (!valid) {
      //休息时间 暂不接客
      return false;
    }
    // 工作时间，执行函数并且在间隔期内把状态位设为无效
    valid = false;
    setTimeout(() => {
      fn();
      valid = true;
    }, delay);
  };
};

Vue.prototype.$noToChinese = num => {
  //阿拉伯数字转中文数字
  if (!/^\d*(\.\d*)?$/.test(num)) {
    return "Number is wrong!";
  }
  var AA = new Array(
    "零",
    "一",
    "二",
    "三",
    "四",
    "五",
    "六",
    "七",
    "八",
    "九"
  );
  var BB = new Array("", "十", "百", "千", "万", "亿", "点", "");
  var a = ("" + num).replace(/(^0*)/g, "").split("."),
    k = 0,
    re = "";
  for (var i = a[0].length - 1; i >= 0; i--) {
    switch (k) {
      case 0:
        re = BB[7] + re;
        break;
      case 4:
        if (!new RegExp("0{4}\\d{" + (a[0].length - i - 1) + "}$").test(a[0]))
          re = BB[4] + re;
        break;
      case 8:
        re = BB[5] + re;
        BB[7] = BB[5];
        k = 0;
        break;
    }
    if (k % 4 == 2 && a[0].charAt(i + 2) != 0 && a[0].charAt(i + 1) == 0)
      re = AA[0] + re;
    if (a[0].charAt(i) != 0) re = AA[a[0].charAt(i)] + BB[k % 4] + re;
    k++;
  }
  if (a.length > 1) {
    //加上小数部分(如果有小数部分)
    re += BB[6];
    for (var i = 0; i < a[1].length; i++) re += AA[a[1].charAt(i)];
  }
  return re;
};



// 统一管理导入图片路径
Vue.prototype.$requireImg = (name) => require(`@/assets/images/${name}`)


